import { Entity } from '@/interfaces'
import model from './model'
import repository from './repository'

const cmsTravelGuidesBlockEntity: Entity = {
  model: model,
  repository: repository,
}

export default cmsTravelGuidesBlockEntity
